<template>
    <div class="milestone-card">
        <div class="milestone-card__header">
            <user-avatar size="medium" :user="milestone.hero"></user-avatar>
            <div class="ms-2" style="flex: 1">
                <span v-if="milestone.hero" class="user-name me-1">{{ milestone.hero.name }}</span>
                <inline-svg src="/assets/img/icons/recommend-icon.svg"></inline-svg>
                {{ milestone.type === 'badge' ?
                milestone.achievement.type === 'first' ? 'received their first Badge' : 'received the Badge'
                : 'finished the activity' }}
                <b>{{ milestone.achievement.title }}</b>
                <div>{{ formatDateTime() }}</div>
            </div>
            <inline-svg class="align-self-start" src="/assets/img/icons/three-dots-icon.svg"></inline-svg>
        </div>
        <div class="milestone-card__content">
            <div v-if="milestone.type === 'badge'">
                <div class="milestone-card__badge">
                    <img v-if="milestone.achievement.image" :src="milestone.achievement.image">
                </div>
                <div class="d-flex flex-column align-items-center">
                    <div class="milestone-card__badge-title mt-4">{{ milestone.achievement.title}}</div>
                    <div class="milestone-card__badge-subtitle">This is great! Send a High Five to the Hero to provide positive reinforcement.
                        <inline-svg src="/assets/img/icons/waving-hand.svg"></inline-svg>
                    </div>
                </div>
            </div>
            <div v-else>
                <img v-if="milestone.achievement.image" class="milestone-card__photo" :src="milestone.achievement.image">
                <div class="milestone-card__powered_by">
                    <span>
                        <inline-svg src="/assets/img/test-logo.svg"></inline-svg>
                    </span>
                    <partner-badge></partner-badge>
                </div>
            </div>
        </div>
        <div class="milestone-card__footer">
            <div class="d-flex flex-row">
                <btn class="action-btn me-4"
                     :loading="loading.save"
                     :class="{disabled: milestone.highFives.myHighFive}"
                     @click="sendHighFive(milestone.highFives.myHighFive)">
                    <inline-svg class="me-1" src="/assets/img/icons/waving-hand.svg"></inline-svg>
                    Send High Five
                </btn>
                <div v-if="milestone.highFives.highFives.length" class="footer-text-400">
                    <inline-svg class="me-1" src="/assets/img/icons/waving-hand-small.svg"></inline-svg>
                    {{ getHighFiveText(milestone.highFives) }}
                </div>
            </div>
            <!--            <a class="action-btn" href="#">-->
            <!--                <inline-svg class="me-1" src="/assets/img/icons/share-07.svg"></inline-svg>-->
            <!--                Share-->
            <!--            </a>-->
        </div>
    </div>
</template>

<script>
import UserAvatar from "@/components/UserAvatar.vue";
import moment from "moment";
import PartnerBadge from "@/components/PartnerBadge.vue";

export default {
    name: 'MilestoneCard',
    components: {PartnerBadge, UserAvatar},
    props: ['milestone'],
    data() {
        return {
            loading: {
                save: false,
            }
        }
    },
    methods: {
        sendHighFive(myHighFive) {
            if (myHighFive) {
                return;
            }
            this.loading.save = true;
            this.$http.post("/reaction/save", {milestone_id: this.milestone.id, type: 'high_five'})
                .then((res) => {
                    this.$events.emit('loadMilestones');
                    this.loading.save = false;
                })
                .catch((error) => {
                    this.loading.save = false;
                });
        },
        formatDateTime() {
            var currentDate = moment();
            var yestedDayDate = moment().subtract(1, 'days');
            // create a date to check
            var dateToCheck = moment(this.milestone.created_at);

            // check if the date to check is today
            if (currentDate.isSame(dateToCheck, 'day')) {
                return 'Today,' + dateToCheck.format(" h:mm a");
            } else if (yestedDayDate.isSame(dateToCheck, 'day')) {
                return 'Yesterday,' + dateToCheck.format(" h:mm a");
            } else if (currentDate.isSame(dateToCheck, 'year')) {
                return dateToCheck.format("d MMM, h:mm a");
            } else {
                return dateToCheck.format("d MMM yyyy, h:mm a");
            }
        },
        getHighFiveText(data) {
            if (!data.highFives.length) {
                return;
            }
            let message = '';
            if (data.myHighFive) {
                message = 'You ';
            } else {
                message = data.highFives[0].caregiver;
            }
            if (data.highFives.length > 1) {
                message += '& ' + (data.highFives.length - 1) + ' others';
            }

            return message;
        }
    }
};

</script>
